$(document).ready(function () {
  var other_elements = gsap.utils.toArray("[gsap-fadin-anim]");
  other_elements.forEach(function (element) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top 95%",
        end: "bottom 50%",
        toggleActions: "play none none none",
      },
    });
    tl.fromTo(
      element,
      { opacity: 0, yPercent: 20 },
      { duration: 1, opacity: 1, yPercent: 0, ease: "cubic" }
    );
  });
});
$('.atc').on('click', function() {
		$('.product-form__submit').trigger('click')
})

$('.custom-btn').on('click', function() {
		$('.shopify-payment-button__button').trigger('click')
})



// $(document).ready(function () {
//     var redirects = {
//       "/products/choclate-pancake": "/products/wholesome-pancake-mix-2-flavours?variant=50157567181088",
//       "/products/wholesome-pancake-mix-banana-fluff": "/products/wholesome-pancake-mix-2-flavours?variant=50157567082784",
//       "/products/4-millet-spinach-chilla-mix": "/products/wholesome-chilla-mix-3-flavours-1-nutritious-deal?variant=50149647188256",
//       "/products/ragi-carrot-chilla-mix": "/products/wholesome-chilla-mix-3-flavours-1-nutritious-deal?variant=50149647319328",
//       "/products/10-millet-beetroot-chilla-mix": "/products/wholesome-chilla-mix-3-flavours-1-nutritious-deal?variant=50149647253792"
//     };

//     var currentPath = window.location.pathname;

//     if (redirects[currentPath]) {
//       window.location.replace(redirects[currentPath]);
//     }
// });